import React from "react";

export interface PerkDisplayProps {
  icon: React.ReactNode;
  value: string | number | JSX.Element;
  label: string;
  crossedOut?: boolean;
  availabilityIcon?: React.ReactNode;
  availabilityLabel?: string;
}

const PerkDisplay: React.FC<PerkDisplayProps> = ({
  icon,
  value,
  label,
  crossedOut = false,
  availabilityIcon,
  availabilityLabel,
}) => {
  const displayValue = availabilityLabel ?? value;
  const showAvailabilityIcon = availabilityIcon != null;

  return (
    <div
      className={`border border-gray-300 rounded-md px-2 py-2 shadow-sm bg-gray-50 flex items-center space-x-2 hover:shadow-md transition w-full min-w-0 ${
        crossedOut ? "opacity-75" : ""
      }`}
    >
      <div className="text-blue-600 flex-shrink-0 text-sm">{icon}</div>
      <div className="flex flex-col break-words w-full min-w-0">
        <span
          className={`text-xs sm:text-sm font-semibold truncate flex items-center gap-1.5 ${
            crossedOut ? "line-through text-gray-500" : "text-gray-900"
          }`}
        >
          {showAvailabilityIcon && (
            <span className={`flex-shrink-0 ${crossedOut ? "text-gray-500" : "text-green-600"}`}>
              {availabilityIcon}
            </span>
          )}
          {displayValue}
        </span>
        <span
          className={`text-xs truncate ${crossedOut ? "line-through text-gray-400" : "text-gray-600"}`}
        >
          {label}
        </span>
      </div>
    </div>
  );
};

export default PerkDisplay;
